<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="id" slot-scope="id">
          <div>
            <div class="font-weight-bold">{{id}}</div>
          </div>
        </template>
        <template slot="file_name" slot-scope="file_name">
          <div>
            <div class="font-weight-bold">{{file_name}}</div>
          </div>
        </template>
        <template slot="size" slot-scope="size">
          <div>
            <div class="font-weight-bold">{{size ? size + ' KB' : null}}</div>
          </div>
        </template>
        <template slot="mime_type" slot-scope="mime_type">
          <div>{{mime_type}}</div>
        </template>
        <template slot="status" slot-scope="status, record">
          <div>
            <a href="javascript:;" class="btn btn-sm btn-light mr-2"
                  @click="onStatusClick(record, status)">{{ status }}</a>
          </div>
        </template>
        <template slot="created_at" slot-scope="created_at">
          <div>{{moment(created_at).format('DD-MM-YYYY h:m A')}}</div>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a :href= record.file_url  target="_blank" class="btn btn-sm btn-light btn-with-addon mr-2"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-download" />
              </span>
              <!-- <edit-school-class ref="editClass" @edited="handleEdited" /> -->
              Download
            </a>
            <a-tooltip placement="top">
              <span>
                <!-- Delete -->
                <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
                  @click="onDelete(record)"
                >
                  <span class="btn-addon">
                    <i class="btn-addon-icon fe fe-trash" />
                  </span>
                  Delete
                </a>
              </span>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

const columns = [
  {
    title: 'Id No.',
    className: 'text-left',
    width: 60,
    dataIndex: 'id',
    scopedSlots: { customRender: 'id' },
    sorter: (a, b) => a.id.localeCompare(b.id),
  },
  {
    title: 'File name',
    className: 'text-left',
    width: 350,
    dataIndex: 'file_name',
    scopedSlots: { customRender: 'file_name' },
    sorter: (a, b) => a.file_name.localeCompare(b.file_name),
  },
  {
    title: 'Size (KB)',
    className: 'text-left text-gray-6',
    dataIndex: 'size',
    scopedSlots: { customRender: 'size' },
    // sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: 'Type',
    dataIndex: 'mime_type',
    scopedSlots: { customRender: 'mime_type' },
    sorter: (a, b) => a.mime_type - b.mime_type,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    sorter: (a, b) => a.status - b.status,
  },
  {
    title: 'Created at',
    dataIndex: 'created_at',
    scopedSlots: { customRender: 'created_at' },
    sorter: (a, b) => a.created_at - b.created_at,
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'ExportFileTable',
  components: {
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    moment,
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this file?',
        content: 'Click yes to delete the file.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/export/file/' + record.id)
            .then(() => {
              this.$emit('handleUpdateExportFileTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'The file' + record.file_name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    onStatusClick: function (record, status) {
      console.log(record)
      if (status === 'Failed') {
        this.$error({
          title: 'Failed Reason',
          content: record.failed_reason,
        })
      }
    },
  },
}
</script>
